var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,45.5c-2.5-2.2-5.4-4-8.5-5.3c-3-1.2-6.2-1.8-9.5-1.8V16.9c3.2,0,6.4,0.7,9.3,2.1c3.2,1.5,6.1,3.5,8.7,6c2.5-2.5,5.5-4.5,8.7-6c2.9-1.4,6.1-2.1,9.3-2.1v21.5c-3.2,0-6.5,0.6-9.5,1.8C29.4,41.5,26.5,43.3,24,45.5L24,45.5z M24,41.7c2.3-1.7,4.7-3,7.3-4.1c2.5-1,5-1.7,7.7-1.9V20.2c-2.5,0.5-5,1.4-7.2,2.7c-2.8,1.7-5.5,3.7-7.8,6c-2.4-2.3-5.1-4.4-8-6.2c-2.1-1.3-4.5-2.2-7-2.6v15.5c2.6,0.3,5.2,0.9,7.7,1.9C19.3,38.6,21.7,40,24,41.7L24,41.7z M24.1,17.9c-2.1,0-4-0.8-5.5-2.2c-1.5-1.4-2.3-3.4-2.2-5.5c-0.1-2.1,0.8-4,2.2-5.5c1.4-1.5,3.4-2.3,5.5-2.2c4.2-0.1,7.6,3.3,7.7,7.5c0,0.1,0,0.2,0,0.2c0.1,4.2-3.3,7.6-7.5,7.7C24.3,17.9,24.2,17.9,24.1,17.9L24.1,17.9L24.1,17.9z M24.1,14.9c1.2,0,2.5-0.5,3.3-1.4c0.9-0.9,1.4-2.1,1.4-3.4c0-2.6-2.1-4.7-4.7-4.7l0,0c-1.2,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2.1-1.4,3.3C19.4,12.8,21.5,14.9,24.1,14.9L24.1,14.9C24.1,14.9,24.1,14.9,24.1,14.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.d5984cd3ec7c6317c22a3c0b76e113f4.svg";
export { ForwardRef as ReactComponent };